import React from 'react';
import { parseFractionNodes, splitWordMatrixRuns } from '../utils/questionFractions';
import './FractionText.css';

function renderNodes(nodes) {
  return nodes.map((node, index) => renderNode(node, index));
}

function renderNode(node, key) {
  if (node.type === 'text') return <React.Fragment key={key}>{node.text}</React.Fragment>;
  if (node.type === 'sup') return <span key={key} className="qp-sup">{renderNodes(node.body)}</span>;
  if (node.type === 'sub') return <span key={key} className="qp-sub">{renderNodes(node.body)}</span>;
  if (node.type === 'sqrt') {
    return (
      <span key={key} className="qp-sqrt">
        <svg className="qp-sqrt-svg" viewBox="0 0 14 24" preserveAspectRatio="none" aria-hidden="true">
          <path d="M1 12 H5 L8 22 L13 1" fill="none" stroke="currentColor" strokeWidth="1.6" vectorEffect="non-scaling-stroke" />
        </svg>
        <span className="qp-sqrt-body">{renderNodes(node.body)}</span>
      </span>
    );
  }
  if (node.type === 'matrix') {
    return (
      <span key={key} className="qp-matrix">
        <span className="qp-matrix-bracket" aria-hidden="true" />
        <span className="qp-matrix-rows">
          {node.rows.map((row, rowIndex) => (
            <span key={rowIndex} className="qp-matrix-row">
              {row.map((cell, cellIndex) => (
                <span key={cellIndex} className="qp-matrix-cell">{renderNodes(cell)}</span>
              ))}
            </span>
          ))}
        </span>
        <span className="qp-matrix-bracket qp-matrix-bracket--right" aria-hidden="true" />
      </span>
    );
  }
  return (
    <span key={key} className="qp-frac">
      <span className="qp-frac-num">{renderNodes(node.num)}</span>
      <span className="qp-frac-den">{renderNodes(node.den)}</span>
    </span>
  );
}

export default function FractionText({ text }) {
  return parseFractionNodes(text).map((node, index) => renderNode(node, index));
}

/** Prose stays as written. Only a Word matrix [■(...)] is drawn as a grid. */
export function MatrixText({ text }) {
  return splitWordMatrixRuns(text).map((part, index) => (
    part.type === 'matrix'
      ? <FractionText key={index} text={part.text} />
      : <React.Fragment key={index}>{part.text}</React.Fragment>
  ));
}
